<script setup>
import RefundReceipt from 'shared/components/RefundReceipt.vue';
import { useMessageContext } from '../provider.js';

const { content, contentAttributes } = useMessageContext();
</script>

<template>
  <RefundReceipt
    :content="content || ''"
    :content-attributes="contentAttributes || {}"
  />
</template>
